import { render, staticRenderFns } from "./useredit.vue?vue&type=template&id=28380470&scoped=true"
import script from "./useredit.vue?vue&type=script&lang=js"
export * from "./useredit.vue?vue&type=script&lang=js"
import style0 from "./useredit.vue?vue&type=style&index=0&id=28380470&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28380470",
  null
  
)

export default component.exports